/** Thin, guarded access to the Office host (absent when the pane is opened in a plain browser). */

function officeReady(): boolean {
  return typeof Office !== "undefined" && Boolean(Office.context?.requirements);
}

export function isSetSupported(name: string, version: string): boolean {
  if (!officeReady()) return false;
  try {
    return Office.context.requirements.isSetSupported(name, version);
  } catch {
    return false;
  }
}

/** Functional minimum (spec §5.3): the manifest asks for 1.3 so older Word can load the pane and explain. */
export const REQUIRED_WORD_API = "1.6";

export function wordApiSupported(version: string = REQUIRED_WORD_API): boolean {
  return isSetSupported("WordApi", version);
}

/**
 * `Office.context.ui.openBrowserWindow` exists on Windows/Mac (OpenBrowserWindowApi 1.1) but not on Word on
 * the web, where the pane shows a plain link the user clicks instead (spec §6 step 2, rev 1.2).
 */
export function canOpenBrowserWindow(): boolean {
  return isSetSupported("OpenBrowserWindowApi", "1.1");
}

export function openBrowserWindow(url: string): boolean {
  if (!canOpenBrowserWindow()) return false;
  Office.context.ui.openBrowserWindow(url);
  return true;
}
